/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SessionTimeoutRouteImport } from './routes/session-timeout'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthActionRouteImport } from './routes/auth-action'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LegalSubprocessorsRouteImport } from './routes/legal/subprocessors'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as AuthenticatedSelectTenantRouteImport } from './routes/_authenticated/select-tenant'
import { Route as AuthenticatedDocumentRouteImport } from './routes/_authenticated/document'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/_settings'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/_dashboard'
import { Route as AuthenticatedDashboardScanRouteImport } from './routes/_authenticated/_dashboard/scan'
import { Route as AuthenticatedDashboardHomeRouteImport } from './routes/_authenticated/_dashboard/home'
import { Route as AuthenticatedDashboardDocumentsRouteImport } from './routes/_authenticated/_dashboard/documents'
import { Route as AuthenticatedDashboardHomeIndexRouteImport } from './routes/_authenticated/_dashboard/home/index'
import { Route as AuthenticatedDashboardDocumentsIndexRouteImport } from './routes/_authenticated/_dashboard/documents/index'
import { Route as AuthenticatedSettingsUserUserIdRouteImport } from './routes/_authenticated/_settings/user/$userId'
import { Route as AuthenticatedDashboardDocumentsCreatedByMeRouteImport } from './routes/_authenticated/_dashboard/documents/created-by-me'
import { Route as AuthenticatedOrgOrgIdHomeIndexRouteImport } from './routes/_authenticated/org/$orgId/home/index'
import { Route as AuthenticatedOrgOrgIdDocumentsIndexRouteImport } from './routes/_authenticated/org/$orgId/documents/index'
import { Route as AuthenticatedSettingsUserUserIdIndexRouteImport } from './routes/_authenticated/_settings/user/$userId/index'
import { Route as AuthenticatedDashboardDocumentsTrashIndexRouteImport } from './routes/_authenticated/_dashboard/documents/trash/index'
import { Route as AuthenticatedOrgOrgIdDocumentsCreatedByMeRouteImport } from './routes/_authenticated/org/$orgId/documents/created-by-me'
import { Route as AuthenticatedSettingsUserUserIdMyProfileRouteImport } from './routes/_authenticated/_settings/user/$userId/my-profile'
import { Route as AuthenticatedSettingsUserUserIdAdvancedSettingsRouteImport } from './routes/_authenticated/_settings/user/$userId/advanced-settings'
import { Route as AuthenticatedSettingsUserUserIdAdminRouteImport } from './routes/_authenticated/_settings/user/$userId/admin'
import { Route as AuthenticatedDashboardOperatorProjectsProjectIdRouteImport } from './routes/_authenticated/_dashboard/operator/projects/$projectId'
import { Route as AuthenticatedDashboardDocumentsProjectsProjectIdRouteImport } from './routes/_authenticated/_dashboard/documents/projects/$projectId'
import { Route as AuthenticatedOrgOrgIdProjectsProjectIdIndexRouteImport } from './routes/_authenticated/org/$orgId/projects/$projectId/index'
import { Route as AuthenticatedOrgOrgIdDocumentsTrashIndexRouteImport } from './routes/_authenticated/org/$orgId/documents/trash/index'
import { Route as AuthenticatedDashboardDocumentsProjectsProjectIdIndexRouteImport } from './routes/_authenticated/_dashboard/documents/projects/$projectId/index'
import { Route as AuthenticatedOrgOrgIdProjectsProjectIdSopsRouteImport } from './routes/_authenticated/org/$orgId/projects/$projectId/sops'
import { Route as AuthenticatedSettingsUserUserIdAdminUserManagementRouteImport } from './routes/_authenticated/_settings/user/$userId/admin/user-management'
import { Route as AuthenticatedSettingsUserUserIdAdminMaintenanceRouteImport } from './routes/_authenticated/_settings/user/$userId/admin/maintenance'
import { Route as AuthenticatedSettingsUserUserIdAdminLanguageRouteImport } from './routes/_authenticated/_settings/user/$userId/admin/language'
import { Route as AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRouteImport } from './routes/_authenticated/org/$orgId/projects/$projectId/sops/$sopId'
import { Route as AuthenticatedOrgOrgIdProjectsProjectIdDocumentsDocIdRouteImport } from './routes/_authenticated/org/$orgId/projects/$projectId/documents/$docId'
import { Route as AuthenticatedOrgOrgIdProjectsProjectIdDocumentDocIdRouteImport } from './routes/_authenticated/org/$orgId/projects/$projectId/document/$docId'
import { Route as AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdIndexRouteImport } from './routes/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/index'
import { Route as AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdStepsRouteImport } from './routes/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/steps'
import { Route as AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdInsightsRouteImport } from './routes/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/insights'
import { Route as AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdFullVideoRouteImport } from './routes/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/full-video'
import { Route as AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdDiagnosticsRouteImport } from './routes/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/diagnostics'

const SessionTimeoutRoute = SessionTimeoutRouteImport.update({
  id: '/session-timeout',
  path: '/session-timeout',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthActionRoute = AuthActionRouteImport.update({
  id: '/auth-action',
  path: '/auth-action',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalSubprocessorsRoute = LegalSubprocessorsRouteImport.update({
  id: '/legal/subprocessors',
  path: '/legal/subprocessors',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
  id: '/legal/privacy',
  path: '/legal/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSelectTenantRoute =
  AuthenticatedSelectTenantRouteImport.update({
    id: '/select-tenant',
    path: '/select-tenant',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDocumentRoute = AuthenticatedDocumentRouteImport.update({
  id: '/document',
  path: '/document',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/_settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardScanRoute =
  AuthenticatedDashboardScanRouteImport.update({
    id: '/scan',
    path: '/scan',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardHomeRoute =
  AuthenticatedDashboardHomeRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardDocumentsRoute =
  AuthenticatedDashboardDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardHomeIndexRoute =
  AuthenticatedDashboardHomeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardHomeRoute,
  } as any)
const AuthenticatedDashboardDocumentsIndexRoute =
  AuthenticatedDashboardDocumentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardDocumentsRoute,
  } as any)
const AuthenticatedSettingsUserUserIdRoute =
  AuthenticatedSettingsUserUserIdRouteImport.update({
    id: '/user/$userId',
    path: '/user/$userId',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedDashboardDocumentsCreatedByMeRoute =
  AuthenticatedDashboardDocumentsCreatedByMeRouteImport.update({
    id: '/created-by-me',
    path: '/created-by-me',
    getParentRoute: () => AuthenticatedDashboardDocumentsRoute,
  } as any)
const AuthenticatedOrgOrgIdHomeIndexRoute =
  AuthenticatedOrgOrgIdHomeIndexRouteImport.update({
    id: '/org/$orgId/home/',
    path: '/org/$orgId/home/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgOrgIdDocumentsIndexRoute =
  AuthenticatedOrgOrgIdDocumentsIndexRouteImport.update({
    id: '/org/$orgId/documents/',
    path: '/org/$orgId/documents/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsUserUserIdIndexRoute =
  AuthenticatedSettingsUserUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsUserUserIdRoute,
  } as any)
const AuthenticatedDashboardDocumentsTrashIndexRoute =
  AuthenticatedDashboardDocumentsTrashIndexRouteImport.update({
    id: '/trash/',
    path: '/trash/',
    getParentRoute: () => AuthenticatedDashboardDocumentsRoute,
  } as any)
const AuthenticatedOrgOrgIdDocumentsCreatedByMeRoute =
  AuthenticatedOrgOrgIdDocumentsCreatedByMeRouteImport.update({
    id: '/org/$orgId/documents/created-by-me',
    path: '/org/$orgId/documents/created-by-me',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsUserUserIdMyProfileRoute =
  AuthenticatedSettingsUserUserIdMyProfileRouteImport.update({
    id: '/my-profile',
    path: '/my-profile',
    getParentRoute: () => AuthenticatedSettingsUserUserIdRoute,
  } as any)
const AuthenticatedSettingsUserUserIdAdvancedSettingsRoute =
  AuthenticatedSettingsUserUserIdAdvancedSettingsRouteImport.update({
    id: '/advanced-settings',
    path: '/advanced-settings',
    getParentRoute: () => AuthenticatedSettingsUserUserIdRoute,
  } as any)
const AuthenticatedSettingsUserUserIdAdminRoute =
  AuthenticatedSettingsUserUserIdAdminRouteImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => AuthenticatedSettingsUserUserIdRoute,
  } as any)
const AuthenticatedDashboardOperatorProjectsProjectIdRoute =
  AuthenticatedDashboardOperatorProjectsProjectIdRouteImport.update({
    id: '/operator/projects/$projectId',
    path: '/operator/projects/$projectId',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardDocumentsProjectsProjectIdRoute =
  AuthenticatedDashboardDocumentsProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AuthenticatedDashboardDocumentsRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsProjectIdIndexRoute =
  AuthenticatedOrgOrgIdProjectsProjectIdIndexRouteImport.update({
    id: '/org/$orgId/projects/$projectId/',
    path: '/org/$orgId/projects/$projectId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgOrgIdDocumentsTrashIndexRoute =
  AuthenticatedOrgOrgIdDocumentsTrashIndexRouteImport.update({
    id: '/org/$orgId/documents/trash/',
    path: '/org/$orgId/documents/trash/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardDocumentsProjectsProjectIdIndexRoute =
  AuthenticatedDashboardDocumentsProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardDocumentsProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsProjectIdSopsRoute =
  AuthenticatedOrgOrgIdProjectsProjectIdSopsRouteImport.update({
    id: '/org/$orgId/projects/$projectId/sops',
    path: '/org/$orgId/projects/$projectId/sops',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsUserUserIdAdminUserManagementRoute =
  AuthenticatedSettingsUserUserIdAdminUserManagementRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => AuthenticatedSettingsUserUserIdAdminRoute,
  } as any)
const AuthenticatedSettingsUserUserIdAdminMaintenanceRoute =
  AuthenticatedSettingsUserUserIdAdminMaintenanceRouteImport.update({
    id: '/maintenance',
    path: '/maintenance',
    getParentRoute: () => AuthenticatedSettingsUserUserIdAdminRoute,
  } as any)
const AuthenticatedSettingsUserUserIdAdminLanguageRoute =
  AuthenticatedSettingsUserUserIdAdminLanguageRouteImport.update({
    id: '/language',
    path: '/language',
    getParentRoute: () => AuthenticatedSettingsUserUserIdAdminRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRoute =
  AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRouteImport.update({
    id: '/$sopId',
    path: '/$sopId',
    getParentRoute: () => AuthenticatedOrgOrgIdProjectsProjectIdSopsRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsProjectIdDocumentsDocIdRoute =
  AuthenticatedOrgOrgIdProjectsProjectIdDocumentsDocIdRouteImport.update({
    id: '/org/$orgId/projects/$projectId/documents/$docId',
    path: '/org/$orgId/projects/$projectId/documents/$docId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsProjectIdDocumentDocIdRoute =
  AuthenticatedOrgOrgIdProjectsProjectIdDocumentDocIdRouteImport.update({
    id: '/org/$orgId/projects/$projectId/document/$docId',
    path: '/org/$orgId/projects/$projectId/document/$docId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdIndexRoute =
  AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdStepsRoute =
  AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdStepsRouteImport.update({
    id: '/steps',
    path: '/steps',
    getParentRoute: () => AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdInsightsRoute =
  AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdFullVideoRoute =
  AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdFullVideoRouteImport.update({
    id: '/full-video',
    path: '/full-video',
    getParentRoute: () => AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdDiagnosticsRoute =
  AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdDiagnosticsRouteImport.update({
    id: '/diagnostics',
    path: '/diagnostics',
    getParentRoute: () => AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth-action': typeof AuthActionRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/session-timeout': typeof SessionTimeoutRoute
  '/document': typeof AuthenticatedDocumentRoute
  '/select-tenant': typeof AuthenticatedSelectTenantRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/subprocessors': typeof LegalSubprocessorsRoute
  '/documents': typeof AuthenticatedDashboardDocumentsRouteWithChildren
  '/home': typeof AuthenticatedDashboardHomeRouteWithChildren
  '/scan': typeof AuthenticatedDashboardScanRoute
  '/documents/created-by-me': typeof AuthenticatedDashboardDocumentsCreatedByMeRoute
  '/user/$userId': typeof AuthenticatedSettingsUserUserIdRouteWithChildren
  '/documents/': typeof AuthenticatedDashboardDocumentsIndexRoute
  '/home/': typeof AuthenticatedDashboardHomeIndexRoute
  '/documents/projects/$projectId': typeof AuthenticatedDashboardDocumentsProjectsProjectIdRouteWithChildren
  '/operator/projects/$projectId': typeof AuthenticatedDashboardOperatorProjectsProjectIdRoute
  '/user/$userId/admin': typeof AuthenticatedSettingsUserUserIdAdminRouteWithChildren
  '/user/$userId/advanced-settings': typeof AuthenticatedSettingsUserUserIdAdvancedSettingsRoute
  '/user/$userId/my-profile': typeof AuthenticatedSettingsUserUserIdMyProfileRoute
  '/org/$orgId/documents/created-by-me': typeof AuthenticatedOrgOrgIdDocumentsCreatedByMeRoute
  '/documents/trash': typeof AuthenticatedDashboardDocumentsTrashIndexRoute
  '/user/$userId/': typeof AuthenticatedSettingsUserUserIdIndexRoute
  '/org/$orgId/documents': typeof AuthenticatedOrgOrgIdDocumentsIndexRoute
  '/org/$orgId/home': typeof AuthenticatedOrgOrgIdHomeIndexRoute
  '/user/$userId/admin/language': typeof AuthenticatedSettingsUserUserIdAdminLanguageRoute
  '/user/$userId/admin/maintenance': typeof AuthenticatedSettingsUserUserIdAdminMaintenanceRoute
  '/user/$userId/admin/user-management': typeof AuthenticatedSettingsUserUserIdAdminUserManagementRoute
  '/org/$orgId/projects/$projectId/sops': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsRouteWithChildren
  '/documents/projects/$projectId/': typeof AuthenticatedDashboardDocumentsProjectsProjectIdIndexRoute
  '/org/$orgId/documents/trash': typeof AuthenticatedOrgOrgIdDocumentsTrashIndexRoute
  '/org/$orgId/projects/$projectId': typeof AuthenticatedOrgOrgIdProjectsProjectIdIndexRoute
  '/org/$orgId/projects/$projectId/document/$docId': typeof AuthenticatedOrgOrgIdProjectsProjectIdDocumentDocIdRoute
  '/org/$orgId/projects/$projectId/documents/$docId': typeof AuthenticatedOrgOrgIdProjectsProjectIdDocumentsDocIdRoute
  '/org/$orgId/projects/$projectId/sops/$sopId': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRouteWithChildren
  '/org/$orgId/projects/$projectId/sops/$sopId/diagnostics': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdDiagnosticsRoute
  '/org/$orgId/projects/$projectId/sops/$sopId/full-video': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdFullVideoRoute
  '/org/$orgId/projects/$projectId/sops/$sopId/insights': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdInsightsRoute
  '/org/$orgId/projects/$projectId/sops/$sopId/steps': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdStepsRoute
  '/org/$orgId/projects/$projectId/sops/$sopId/': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth-action': typeof AuthActionRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/session-timeout': typeof SessionTimeoutRoute
  '/document': typeof AuthenticatedDocumentRoute
  '/select-tenant': typeof AuthenticatedSelectTenantRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/subprocessors': typeof LegalSubprocessorsRoute
  '/scan': typeof AuthenticatedDashboardScanRoute
  '/documents/created-by-me': typeof AuthenticatedDashboardDocumentsCreatedByMeRoute
  '/documents': typeof AuthenticatedDashboardDocumentsIndexRoute
  '/home': typeof AuthenticatedDashboardHomeIndexRoute
  '/operator/projects/$projectId': typeof AuthenticatedDashboardOperatorProjectsProjectIdRoute
  '/user/$userId/admin': typeof AuthenticatedSettingsUserUserIdAdminRouteWithChildren
  '/user/$userId/advanced-settings': typeof AuthenticatedSettingsUserUserIdAdvancedSettingsRoute
  '/user/$userId/my-profile': typeof AuthenticatedSettingsUserUserIdMyProfileRoute
  '/org/$orgId/documents/created-by-me': typeof AuthenticatedOrgOrgIdDocumentsCreatedByMeRoute
  '/documents/trash': typeof AuthenticatedDashboardDocumentsTrashIndexRoute
  '/user/$userId': typeof AuthenticatedSettingsUserUserIdIndexRoute
  '/org/$orgId/documents': typeof AuthenticatedOrgOrgIdDocumentsIndexRoute
  '/org/$orgId/home': typeof AuthenticatedOrgOrgIdHomeIndexRoute
  '/user/$userId/admin/language': typeof AuthenticatedSettingsUserUserIdAdminLanguageRoute
  '/user/$userId/admin/maintenance': typeof AuthenticatedSettingsUserUserIdAdminMaintenanceRoute
  '/user/$userId/admin/user-management': typeof AuthenticatedSettingsUserUserIdAdminUserManagementRoute
  '/org/$orgId/projects/$projectId/sops': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsRouteWithChildren
  '/documents/projects/$projectId': typeof AuthenticatedDashboardDocumentsProjectsProjectIdIndexRoute
  '/org/$orgId/documents/trash': typeof AuthenticatedOrgOrgIdDocumentsTrashIndexRoute
  '/org/$orgId/projects/$projectId': typeof AuthenticatedOrgOrgIdProjectsProjectIdIndexRoute
  '/org/$orgId/projects/$projectId/document/$docId': typeof AuthenticatedOrgOrgIdProjectsProjectIdDocumentDocIdRoute
  '/org/$orgId/projects/$projectId/documents/$docId': typeof AuthenticatedOrgOrgIdProjectsProjectIdDocumentsDocIdRoute
  '/org/$orgId/projects/$projectId/sops/$sopId/diagnostics': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdDiagnosticsRoute
  '/org/$orgId/projects/$projectId/sops/$sopId/full-video': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdFullVideoRoute
  '/org/$orgId/projects/$projectId/sops/$sopId/insights': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdInsightsRoute
  '/org/$orgId/projects/$projectId/sops/$sopId/steps': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdStepsRoute
  '/org/$orgId/projects/$projectId/sops/$sopId': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/auth-action': typeof AuthActionRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/session-timeout': typeof SessionTimeoutRoute
  '/_authenticated/_dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/_authenticated/_settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/document': typeof AuthenticatedDocumentRoute
  '/_authenticated/select-tenant': typeof AuthenticatedSelectTenantRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/subprocessors': typeof LegalSubprocessorsRoute
  '/_authenticated/_dashboard/documents': typeof AuthenticatedDashboardDocumentsRouteWithChildren
  '/_authenticated/_dashboard/home': typeof AuthenticatedDashboardHomeRouteWithChildren
  '/_authenticated/_dashboard/scan': typeof AuthenticatedDashboardScanRoute
  '/_authenticated/_dashboard/documents/created-by-me': typeof AuthenticatedDashboardDocumentsCreatedByMeRoute
  '/_authenticated/_settings/user/$userId': typeof AuthenticatedSettingsUserUserIdRouteWithChildren
  '/_authenticated/_dashboard/documents/': typeof AuthenticatedDashboardDocumentsIndexRoute
  '/_authenticated/_dashboard/home/': typeof AuthenticatedDashboardHomeIndexRoute
  '/_authenticated/_dashboard/documents/projects/$projectId': typeof AuthenticatedDashboardDocumentsProjectsProjectIdRouteWithChildren
  '/_authenticated/_dashboard/operator/projects/$projectId': typeof AuthenticatedDashboardOperatorProjectsProjectIdRoute
  '/_authenticated/_settings/user/$userId/admin': typeof AuthenticatedSettingsUserUserIdAdminRouteWithChildren
  '/_authenticated/_settings/user/$userId/advanced-settings': typeof AuthenticatedSettingsUserUserIdAdvancedSettingsRoute
  '/_authenticated/_settings/user/$userId/my-profile': typeof AuthenticatedSettingsUserUserIdMyProfileRoute
  '/_authenticated/org/$orgId/documents/created-by-me': typeof AuthenticatedOrgOrgIdDocumentsCreatedByMeRoute
  '/_authenticated/_dashboard/documents/trash/': typeof AuthenticatedDashboardDocumentsTrashIndexRoute
  '/_authenticated/_settings/user/$userId/': typeof AuthenticatedSettingsUserUserIdIndexRoute
  '/_authenticated/org/$orgId/documents/': typeof AuthenticatedOrgOrgIdDocumentsIndexRoute
  '/_authenticated/org/$orgId/home/': typeof AuthenticatedOrgOrgIdHomeIndexRoute
  '/_authenticated/_settings/user/$userId/admin/language': typeof AuthenticatedSettingsUserUserIdAdminLanguageRoute
  '/_authenticated/_settings/user/$userId/admin/maintenance': typeof AuthenticatedSettingsUserUserIdAdminMaintenanceRoute
  '/_authenticated/_settings/user/$userId/admin/user-management': typeof AuthenticatedSettingsUserUserIdAdminUserManagementRoute
  '/_authenticated/org/$orgId/projects/$projectId/sops': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsRouteWithChildren
  '/_authenticated/_dashboard/documents/projects/$projectId/': typeof AuthenticatedDashboardDocumentsProjectsProjectIdIndexRoute
  '/_authenticated/org/$orgId/documents/trash/': typeof AuthenticatedOrgOrgIdDocumentsTrashIndexRoute
  '/_authenticated/org/$orgId/projects/$projectId/': typeof AuthenticatedOrgOrgIdProjectsProjectIdIndexRoute
  '/_authenticated/org/$orgId/projects/$projectId/document/$docId': typeof AuthenticatedOrgOrgIdProjectsProjectIdDocumentDocIdRoute
  '/_authenticated/org/$orgId/projects/$projectId/documents/$docId': typeof AuthenticatedOrgOrgIdProjectsProjectIdDocumentsDocIdRoute
  '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRouteWithChildren
  '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/diagnostics': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdDiagnosticsRoute
  '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/full-video': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdFullVideoRoute
  '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/insights': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdInsightsRoute
  '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/steps': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdStepsRoute
  '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/': typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth-action'
    | '/login'
    | '/logout'
    | '/session-timeout'
    | '/document'
    | '/select-tenant'
    | '/legal/privacy'
    | '/legal/subprocessors'
    | '/documents'
    | '/home'
    | '/scan'
    | '/documents/created-by-me'
    | '/user/$userId'
    | '/documents/'
    | '/home/'
    | '/documents/projects/$projectId'
    | '/operator/projects/$projectId'
    | '/user/$userId/admin'
    | '/user/$userId/advanced-settings'
    | '/user/$userId/my-profile'
    | '/org/$orgId/documents/created-by-me'
    | '/documents/trash'
    | '/user/$userId/'
    | '/org/$orgId/documents'
    | '/org/$orgId/home'
    | '/user/$userId/admin/language'
    | '/user/$userId/admin/maintenance'
    | '/user/$userId/admin/user-management'
    | '/org/$orgId/projects/$projectId/sops'
    | '/documents/projects/$projectId/'
    | '/org/$orgId/documents/trash'
    | '/org/$orgId/projects/$projectId'
    | '/org/$orgId/projects/$projectId/document/$docId'
    | '/org/$orgId/projects/$projectId/documents/$docId'
    | '/org/$orgId/projects/$projectId/sops/$sopId'
    | '/org/$orgId/projects/$projectId/sops/$sopId/diagnostics'
    | '/org/$orgId/projects/$projectId/sops/$sopId/full-video'
    | '/org/$orgId/projects/$projectId/sops/$sopId/insights'
    | '/org/$orgId/projects/$projectId/sops/$sopId/steps'
    | '/org/$orgId/projects/$projectId/sops/$sopId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth-action'
    | '/login'
    | '/logout'
    | '/session-timeout'
    | '/document'
    | '/select-tenant'
    | '/legal/privacy'
    | '/legal/subprocessors'
    | '/scan'
    | '/documents/created-by-me'
    | '/documents'
    | '/home'
    | '/operator/projects/$projectId'
    | '/user/$userId/admin'
    | '/user/$userId/advanced-settings'
    | '/user/$userId/my-profile'
    | '/org/$orgId/documents/created-by-me'
    | '/documents/trash'
    | '/user/$userId'
    | '/org/$orgId/documents'
    | '/org/$orgId/home'
    | '/user/$userId/admin/language'
    | '/user/$userId/admin/maintenance'
    | '/user/$userId/admin/user-management'
    | '/org/$orgId/projects/$projectId/sops'
    | '/documents/projects/$projectId'
    | '/org/$orgId/documents/trash'
    | '/org/$orgId/projects/$projectId'
    | '/org/$orgId/projects/$projectId/document/$docId'
    | '/org/$orgId/projects/$projectId/documents/$docId'
    | '/org/$orgId/projects/$projectId/sops/$sopId/diagnostics'
    | '/org/$orgId/projects/$projectId/sops/$sopId/full-video'
    | '/org/$orgId/projects/$projectId/sops/$sopId/insights'
    | '/org/$orgId/projects/$projectId/sops/$sopId/steps'
    | '/org/$orgId/projects/$projectId/sops/$sopId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/auth-action'
    | '/login'
    | '/logout'
    | '/session-timeout'
    | '/_authenticated/_dashboard'
    | '/_authenticated/_settings'
    | '/_authenticated/document'
    | '/_authenticated/select-tenant'
    | '/legal/privacy'
    | '/legal/subprocessors'
    | '/_authenticated/_dashboard/documents'
    | '/_authenticated/_dashboard/home'
    | '/_authenticated/_dashboard/scan'
    | '/_authenticated/_dashboard/documents/created-by-me'
    | '/_authenticated/_settings/user/$userId'
    | '/_authenticated/_dashboard/documents/'
    | '/_authenticated/_dashboard/home/'
    | '/_authenticated/_dashboard/documents/projects/$projectId'
    | '/_authenticated/_dashboard/operator/projects/$projectId'
    | '/_authenticated/_settings/user/$userId/admin'
    | '/_authenticated/_settings/user/$userId/advanced-settings'
    | '/_authenticated/_settings/user/$userId/my-profile'
    | '/_authenticated/org/$orgId/documents/created-by-me'
    | '/_authenticated/_dashboard/documents/trash/'
    | '/_authenticated/_settings/user/$userId/'
    | '/_authenticated/org/$orgId/documents/'
    | '/_authenticated/org/$orgId/home/'
    | '/_authenticated/_settings/user/$userId/admin/language'
    | '/_authenticated/_settings/user/$userId/admin/maintenance'
    | '/_authenticated/_settings/user/$userId/admin/user-management'
    | '/_authenticated/org/$orgId/projects/$projectId/sops'
    | '/_authenticated/_dashboard/documents/projects/$projectId/'
    | '/_authenticated/org/$orgId/documents/trash/'
    | '/_authenticated/org/$orgId/projects/$projectId/'
    | '/_authenticated/org/$orgId/projects/$projectId/document/$docId'
    | '/_authenticated/org/$orgId/projects/$projectId/documents/$docId'
    | '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId'
    | '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/diagnostics'
    | '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/full-video'
    | '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/insights'
    | '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/steps'
    | '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthActionRoute: typeof AuthActionRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  SessionTimeoutRoute: typeof SessionTimeoutRoute
  LegalPrivacyRoute: typeof LegalPrivacyRoute
  LegalSubprocessorsRoute: typeof LegalSubprocessorsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/session-timeout': {
      id: '/session-timeout'
      path: '/session-timeout'
      fullPath: '/session-timeout'
      preLoaderRoute: typeof SessionTimeoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-action': {
      id: '/auth-action'
      path: '/auth-action'
      fullPath: '/auth-action'
      preLoaderRoute: typeof AuthActionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/subprocessors': {
      id: '/legal/subprocessors'
      path: '/legal/subprocessors'
      fullPath: '/legal/subprocessors'
      preLoaderRoute: typeof LegalSubprocessorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/privacy': {
      id: '/legal/privacy'
      path: '/legal/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof LegalPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/select-tenant': {
      id: '/_authenticated/select-tenant'
      path: '/select-tenant'
      fullPath: '/select-tenant'
      preLoaderRoute: typeof AuthenticatedSelectTenantRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/document': {
      id: '/_authenticated/document'
      path: '/document'
      fullPath: '/document'
      preLoaderRoute: typeof AuthenticatedDocumentRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_settings': {
      id: '/_authenticated/_settings'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_dashboard': {
      id: '/_authenticated/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_dashboard/scan': {
      id: '/_authenticated/_dashboard/scan'
      path: '/scan'
      fullPath: '/scan'
      preLoaderRoute: typeof AuthenticatedDashboardScanRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/home': {
      id: '/_authenticated/_dashboard/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedDashboardHomeRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/documents': {
      id: '/_authenticated/_dashboard/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthenticatedDashboardDocumentsRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/home/': {
      id: '/_authenticated/_dashboard/home/'
      path: '/'
      fullPath: '/home/'
      preLoaderRoute: typeof AuthenticatedDashboardHomeIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardHomeRoute
    }
    '/_authenticated/_dashboard/documents/': {
      id: '/_authenticated/_dashboard/documents/'
      path: '/'
      fullPath: '/documents/'
      preLoaderRoute: typeof AuthenticatedDashboardDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardDocumentsRoute
    }
    '/_authenticated/_settings/user/$userId': {
      id: '/_authenticated/_settings/user/$userId'
      path: '/user/$userId'
      fullPath: '/user/$userId'
      preLoaderRoute: typeof AuthenticatedSettingsUserUserIdRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/_dashboard/documents/created-by-me': {
      id: '/_authenticated/_dashboard/documents/created-by-me'
      path: '/created-by-me'
      fullPath: '/documents/created-by-me'
      preLoaderRoute: typeof AuthenticatedDashboardDocumentsCreatedByMeRouteImport
      parentRoute: typeof AuthenticatedDashboardDocumentsRoute
    }
    '/_authenticated/org/$orgId/home/': {
      id: '/_authenticated/org/$orgId/home/'
      path: '/org/$orgId/home'
      fullPath: '/org/$orgId/home'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdHomeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/$orgId/documents/': {
      id: '/_authenticated/org/$orgId/documents/'
      path: '/org/$orgId/documents'
      fullPath: '/org/$orgId/documents'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_settings/user/$userId/': {
      id: '/_authenticated/_settings/user/$userId/'
      path: '/'
      fullPath: '/user/$userId/'
      preLoaderRoute: typeof AuthenticatedSettingsUserUserIdIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsUserUserIdRoute
    }
    '/_authenticated/_dashboard/documents/trash/': {
      id: '/_authenticated/_dashboard/documents/trash/'
      path: '/trash'
      fullPath: '/documents/trash'
      preLoaderRoute: typeof AuthenticatedDashboardDocumentsTrashIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardDocumentsRoute
    }
    '/_authenticated/org/$orgId/documents/created-by-me': {
      id: '/_authenticated/org/$orgId/documents/created-by-me'
      path: '/org/$orgId/documents/created-by-me'
      fullPath: '/org/$orgId/documents/created-by-me'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdDocumentsCreatedByMeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_settings/user/$userId/my-profile': {
      id: '/_authenticated/_settings/user/$userId/my-profile'
      path: '/my-profile'
      fullPath: '/user/$userId/my-profile'
      preLoaderRoute: typeof AuthenticatedSettingsUserUserIdMyProfileRouteImport
      parentRoute: typeof AuthenticatedSettingsUserUserIdRoute
    }
    '/_authenticated/_settings/user/$userId/advanced-settings': {
      id: '/_authenticated/_settings/user/$userId/advanced-settings'
      path: '/advanced-settings'
      fullPath: '/user/$userId/advanced-settings'
      preLoaderRoute: typeof AuthenticatedSettingsUserUserIdAdvancedSettingsRouteImport
      parentRoute: typeof AuthenticatedSettingsUserUserIdRoute
    }
    '/_authenticated/_settings/user/$userId/admin': {
      id: '/_authenticated/_settings/user/$userId/admin'
      path: '/admin'
      fullPath: '/user/$userId/admin'
      preLoaderRoute: typeof AuthenticatedSettingsUserUserIdAdminRouteImport
      parentRoute: typeof AuthenticatedSettingsUserUserIdRoute
    }
    '/_authenticated/_dashboard/operator/projects/$projectId': {
      id: '/_authenticated/_dashboard/operator/projects/$projectId'
      path: '/operator/projects/$projectId'
      fullPath: '/operator/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedDashboardOperatorProjectsProjectIdRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/documents/projects/$projectId': {
      id: '/_authenticated/_dashboard/documents/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/documents/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedDashboardDocumentsProjectsProjectIdRouteImport
      parentRoute: typeof AuthenticatedDashboardDocumentsRoute
    }
    '/_authenticated/org/$orgId/projects/$projectId/': {
      id: '/_authenticated/org/$orgId/projects/$projectId/'
      path: '/org/$orgId/projects/$projectId'
      fullPath: '/org/$orgId/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/$orgId/documents/trash/': {
      id: '/_authenticated/org/$orgId/documents/trash/'
      path: '/org/$orgId/documents/trash'
      fullPath: '/org/$orgId/documents/trash'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdDocumentsTrashIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_dashboard/documents/projects/$projectId/': {
      id: '/_authenticated/_dashboard/documents/projects/$projectId/'
      path: '/'
      fullPath: '/documents/projects/$projectId/'
      preLoaderRoute: typeof AuthenticatedDashboardDocumentsProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardDocumentsProjectsProjectIdRoute
    }
    '/_authenticated/org/$orgId/projects/$projectId/sops': {
      id: '/_authenticated/org/$orgId/projects/$projectId/sops'
      path: '/org/$orgId/projects/$projectId/sops'
      fullPath: '/org/$orgId/projects/$projectId/sops'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_settings/user/$userId/admin/user-management': {
      id: '/_authenticated/_settings/user/$userId/admin/user-management'
      path: '/user-management'
      fullPath: '/user/$userId/admin/user-management'
      preLoaderRoute: typeof AuthenticatedSettingsUserUserIdAdminUserManagementRouteImport
      parentRoute: typeof AuthenticatedSettingsUserUserIdAdminRoute
    }
    '/_authenticated/_settings/user/$userId/admin/maintenance': {
      id: '/_authenticated/_settings/user/$userId/admin/maintenance'
      path: '/maintenance'
      fullPath: '/user/$userId/admin/maintenance'
      preLoaderRoute: typeof AuthenticatedSettingsUserUserIdAdminMaintenanceRouteImport
      parentRoute: typeof AuthenticatedSettingsUserUserIdAdminRoute
    }
    '/_authenticated/_settings/user/$userId/admin/language': {
      id: '/_authenticated/_settings/user/$userId/admin/language'
      path: '/language'
      fullPath: '/user/$userId/admin/language'
      preLoaderRoute: typeof AuthenticatedSettingsUserUserIdAdminLanguageRouteImport
      parentRoute: typeof AuthenticatedSettingsUserUserIdAdminRoute
    }
    '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId': {
      id: '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId'
      path: '/$sopId'
      fullPath: '/org/$orgId/projects/$projectId/sops/$sopId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsRoute
    }
    '/_authenticated/org/$orgId/projects/$projectId/documents/$docId': {
      id: '/_authenticated/org/$orgId/projects/$projectId/documents/$docId'
      path: '/org/$orgId/projects/$projectId/documents/$docId'
      fullPath: '/org/$orgId/projects/$projectId/documents/$docId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdDocumentsDocIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/$orgId/projects/$projectId/document/$docId': {
      id: '/_authenticated/org/$orgId/projects/$projectId/document/$docId'
      path: '/org/$orgId/projects/$projectId/document/$docId'
      fullPath: '/org/$orgId/projects/$projectId/document/$docId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdDocumentDocIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/': {
      id: '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/'
      path: '/'
      fullPath: '/org/$orgId/projects/$projectId/sops/$sopId/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRoute
    }
    '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/steps': {
      id: '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/steps'
      path: '/steps'
      fullPath: '/org/$orgId/projects/$projectId/sops/$sopId/steps'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdStepsRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRoute
    }
    '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/insights': {
      id: '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/insights'
      path: '/insights'
      fullPath: '/org/$orgId/projects/$projectId/sops/$sopId/insights'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdInsightsRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRoute
    }
    '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/full-video': {
      id: '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/full-video'
      path: '/full-video'
      fullPath: '/org/$orgId/projects/$projectId/sops/$sopId/full-video'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdFullVideoRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRoute
    }
    '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/diagnostics': {
      id: '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/diagnostics'
      path: '/diagnostics'
      fullPath: '/org/$orgId/projects/$projectId/sops/$sopId/diagnostics'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdDiagnosticsRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRoute
    }
  }
}

interface AuthenticatedDashboardDocumentsProjectsProjectIdRouteChildren {
  AuthenticatedDashboardDocumentsProjectsProjectIdIndexRoute: typeof AuthenticatedDashboardDocumentsProjectsProjectIdIndexRoute
}

const AuthenticatedDashboardDocumentsProjectsProjectIdRouteChildren: AuthenticatedDashboardDocumentsProjectsProjectIdRouteChildren =
  {
    AuthenticatedDashboardDocumentsProjectsProjectIdIndexRoute:
      AuthenticatedDashboardDocumentsProjectsProjectIdIndexRoute,
  }

const AuthenticatedDashboardDocumentsProjectsProjectIdRouteWithChildren =
  AuthenticatedDashboardDocumentsProjectsProjectIdRoute._addFileChildren(
    AuthenticatedDashboardDocumentsProjectsProjectIdRouteChildren,
  )

interface AuthenticatedDashboardDocumentsRouteChildren {
  AuthenticatedDashboardDocumentsCreatedByMeRoute: typeof AuthenticatedDashboardDocumentsCreatedByMeRoute
  AuthenticatedDashboardDocumentsIndexRoute: typeof AuthenticatedDashboardDocumentsIndexRoute
  AuthenticatedDashboardDocumentsProjectsProjectIdRoute: typeof AuthenticatedDashboardDocumentsProjectsProjectIdRouteWithChildren
  AuthenticatedDashboardDocumentsTrashIndexRoute: typeof AuthenticatedDashboardDocumentsTrashIndexRoute
}

const AuthenticatedDashboardDocumentsRouteChildren: AuthenticatedDashboardDocumentsRouteChildren =
  {
    AuthenticatedDashboardDocumentsCreatedByMeRoute:
      AuthenticatedDashboardDocumentsCreatedByMeRoute,
    AuthenticatedDashboardDocumentsIndexRoute:
      AuthenticatedDashboardDocumentsIndexRoute,
    AuthenticatedDashboardDocumentsProjectsProjectIdRoute:
      AuthenticatedDashboardDocumentsProjectsProjectIdRouteWithChildren,
    AuthenticatedDashboardDocumentsTrashIndexRoute:
      AuthenticatedDashboardDocumentsTrashIndexRoute,
  }

const AuthenticatedDashboardDocumentsRouteWithChildren =
  AuthenticatedDashboardDocumentsRoute._addFileChildren(
    AuthenticatedDashboardDocumentsRouteChildren,
  )

interface AuthenticatedDashboardHomeRouteChildren {
  AuthenticatedDashboardHomeIndexRoute: typeof AuthenticatedDashboardHomeIndexRoute
}

const AuthenticatedDashboardHomeRouteChildren: AuthenticatedDashboardHomeRouteChildren =
  {
    AuthenticatedDashboardHomeIndexRoute: AuthenticatedDashboardHomeIndexRoute,
  }

const AuthenticatedDashboardHomeRouteWithChildren =
  AuthenticatedDashboardHomeRoute._addFileChildren(
    AuthenticatedDashboardHomeRouteChildren,
  )

interface AuthenticatedDashboardRouteChildren {
  AuthenticatedDashboardDocumentsRoute: typeof AuthenticatedDashboardDocumentsRouteWithChildren
  AuthenticatedDashboardHomeRoute: typeof AuthenticatedDashboardHomeRouteWithChildren
  AuthenticatedDashboardScanRoute: typeof AuthenticatedDashboardScanRoute
  AuthenticatedDashboardOperatorProjectsProjectIdRoute: typeof AuthenticatedDashboardOperatorProjectsProjectIdRoute
}

const AuthenticatedDashboardRouteChildren: AuthenticatedDashboardRouteChildren =
  {
    AuthenticatedDashboardDocumentsRoute:
      AuthenticatedDashboardDocumentsRouteWithChildren,
    AuthenticatedDashboardHomeRoute:
      AuthenticatedDashboardHomeRouteWithChildren,
    AuthenticatedDashboardScanRoute: AuthenticatedDashboardScanRoute,
    AuthenticatedDashboardOperatorProjectsProjectIdRoute:
      AuthenticatedDashboardOperatorProjectsProjectIdRoute,
  }

const AuthenticatedDashboardRouteWithChildren =
  AuthenticatedDashboardRoute._addFileChildren(
    AuthenticatedDashboardRouteChildren,
  )

interface AuthenticatedSettingsUserUserIdAdminRouteChildren {
  AuthenticatedSettingsUserUserIdAdminLanguageRoute: typeof AuthenticatedSettingsUserUserIdAdminLanguageRoute
  AuthenticatedSettingsUserUserIdAdminMaintenanceRoute: typeof AuthenticatedSettingsUserUserIdAdminMaintenanceRoute
  AuthenticatedSettingsUserUserIdAdminUserManagementRoute: typeof AuthenticatedSettingsUserUserIdAdminUserManagementRoute
}

const AuthenticatedSettingsUserUserIdAdminRouteChildren: AuthenticatedSettingsUserUserIdAdminRouteChildren =
  {
    AuthenticatedSettingsUserUserIdAdminLanguageRoute:
      AuthenticatedSettingsUserUserIdAdminLanguageRoute,
    AuthenticatedSettingsUserUserIdAdminMaintenanceRoute:
      AuthenticatedSettingsUserUserIdAdminMaintenanceRoute,
    AuthenticatedSettingsUserUserIdAdminUserManagementRoute:
      AuthenticatedSettingsUserUserIdAdminUserManagementRoute,
  }

const AuthenticatedSettingsUserUserIdAdminRouteWithChildren =
  AuthenticatedSettingsUserUserIdAdminRoute._addFileChildren(
    AuthenticatedSettingsUserUserIdAdminRouteChildren,
  )

interface AuthenticatedSettingsUserUserIdRouteChildren {
  AuthenticatedSettingsUserUserIdAdminRoute: typeof AuthenticatedSettingsUserUserIdAdminRouteWithChildren
  AuthenticatedSettingsUserUserIdAdvancedSettingsRoute: typeof AuthenticatedSettingsUserUserIdAdvancedSettingsRoute
  AuthenticatedSettingsUserUserIdMyProfileRoute: typeof AuthenticatedSettingsUserUserIdMyProfileRoute
  AuthenticatedSettingsUserUserIdIndexRoute: typeof AuthenticatedSettingsUserUserIdIndexRoute
}

const AuthenticatedSettingsUserUserIdRouteChildren: AuthenticatedSettingsUserUserIdRouteChildren =
  {
    AuthenticatedSettingsUserUserIdAdminRoute:
      AuthenticatedSettingsUserUserIdAdminRouteWithChildren,
    AuthenticatedSettingsUserUserIdAdvancedSettingsRoute:
      AuthenticatedSettingsUserUserIdAdvancedSettingsRoute,
    AuthenticatedSettingsUserUserIdMyProfileRoute:
      AuthenticatedSettingsUserUserIdMyProfileRoute,
    AuthenticatedSettingsUserUserIdIndexRoute:
      AuthenticatedSettingsUserUserIdIndexRoute,
  }

const AuthenticatedSettingsUserUserIdRouteWithChildren =
  AuthenticatedSettingsUserUserIdRoute._addFileChildren(
    AuthenticatedSettingsUserUserIdRouteChildren,
  )

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsUserUserIdRoute: typeof AuthenticatedSettingsUserUserIdRouteWithChildren
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsUserUserIdRoute:
    AuthenticatedSettingsUserUserIdRouteWithChildren,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRouteChildren {
  AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdDiagnosticsRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdDiagnosticsRoute
  AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdFullVideoRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdFullVideoRoute
  AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdInsightsRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdInsightsRoute
  AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdStepsRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdStepsRoute
  AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdIndexRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdIndexRoute
}

const AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRouteChildren: AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRouteChildren =
  {
    AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdDiagnosticsRoute:
      AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdDiagnosticsRoute,
    AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdFullVideoRoute:
      AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdFullVideoRoute,
    AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdInsightsRoute:
      AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdInsightsRoute,
    AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdStepsRoute:
      AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdStepsRoute,
    AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdIndexRoute:
      AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdIndexRoute,
  }

const AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRouteWithChildren =
  AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRoute._addFileChildren(
    AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRouteChildren,
  )

interface AuthenticatedOrgOrgIdProjectsProjectIdSopsRouteChildren {
  AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRouteWithChildren
}

const AuthenticatedOrgOrgIdProjectsProjectIdSopsRouteChildren: AuthenticatedOrgOrgIdProjectsProjectIdSopsRouteChildren =
  {
    AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRoute:
      AuthenticatedOrgOrgIdProjectsProjectIdSopsSopIdRouteWithChildren,
  }

const AuthenticatedOrgOrgIdProjectsProjectIdSopsRouteWithChildren =
  AuthenticatedOrgOrgIdProjectsProjectIdSopsRoute._addFileChildren(
    AuthenticatedOrgOrgIdProjectsProjectIdSopsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedDocumentRoute: typeof AuthenticatedDocumentRoute
  AuthenticatedSelectTenantRoute: typeof AuthenticatedSelectTenantRoute
  AuthenticatedOrgOrgIdDocumentsCreatedByMeRoute: typeof AuthenticatedOrgOrgIdDocumentsCreatedByMeRoute
  AuthenticatedOrgOrgIdDocumentsIndexRoute: typeof AuthenticatedOrgOrgIdDocumentsIndexRoute
  AuthenticatedOrgOrgIdHomeIndexRoute: typeof AuthenticatedOrgOrgIdHomeIndexRoute
  AuthenticatedOrgOrgIdProjectsProjectIdSopsRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdSopsRouteWithChildren
  AuthenticatedOrgOrgIdDocumentsTrashIndexRoute: typeof AuthenticatedOrgOrgIdDocumentsTrashIndexRoute
  AuthenticatedOrgOrgIdProjectsProjectIdIndexRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdIndexRoute
  AuthenticatedOrgOrgIdProjectsProjectIdDocumentDocIdRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdDocumentDocIdRoute
  AuthenticatedOrgOrgIdProjectsProjectIdDocumentsDocIdRoute: typeof AuthenticatedOrgOrgIdProjectsProjectIdDocumentsDocIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedDocumentRoute: AuthenticatedDocumentRoute,
  AuthenticatedSelectTenantRoute: AuthenticatedSelectTenantRoute,
  AuthenticatedOrgOrgIdDocumentsCreatedByMeRoute:
    AuthenticatedOrgOrgIdDocumentsCreatedByMeRoute,
  AuthenticatedOrgOrgIdDocumentsIndexRoute:
    AuthenticatedOrgOrgIdDocumentsIndexRoute,
  AuthenticatedOrgOrgIdHomeIndexRoute: AuthenticatedOrgOrgIdHomeIndexRoute,
  AuthenticatedOrgOrgIdProjectsProjectIdSopsRoute:
    AuthenticatedOrgOrgIdProjectsProjectIdSopsRouteWithChildren,
  AuthenticatedOrgOrgIdDocumentsTrashIndexRoute:
    AuthenticatedOrgOrgIdDocumentsTrashIndexRoute,
  AuthenticatedOrgOrgIdProjectsProjectIdIndexRoute:
    AuthenticatedOrgOrgIdProjectsProjectIdIndexRoute,
  AuthenticatedOrgOrgIdProjectsProjectIdDocumentDocIdRoute:
    AuthenticatedOrgOrgIdProjectsProjectIdDocumentDocIdRoute,
  AuthenticatedOrgOrgIdProjectsProjectIdDocumentsDocIdRoute:
    AuthenticatedOrgOrgIdProjectsProjectIdDocumentsDocIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthActionRoute: AuthActionRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  SessionTimeoutRoute: SessionTimeoutRoute,
  LegalPrivacyRoute: LegalPrivacyRoute,
  LegalSubprocessorsRoute: LegalSubprocessorsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
